export const CampaignType = {
  None: 0,
  Default: 0b1,
  Shopping: 0b10,
  DynamicSearchAds: 0b100,
  Audience: 0b1000,
  Smart: 0b10000,
  All: 0xFFFF,
};
